module.exports = __webpack_public_path__ + "img/小跳瘙.367d5076.png";